import React from "react";

const NavStoreContext = React.createContext(null);

export function NavStoreProvider({ store, children }) {
  return (
    <NavStoreContext.Provider value={store}>
      {children}
    </NavStoreContext.Provider>
  );
}

const EMPTY_FUND = Object.freeze({
  recommendedCurrencyList: [],
  recommendedCurrencyListMd5: "",
});
const EMPTY_STORE = Object.freeze({ fund: EMPTY_FUND });

export function useNavStore() {
  return React.useContext(NavStoreContext) || EMPTY_STORE;
}
